import { configureStore } from '@reduxjs/toolkit';
import {
  persistStore,
  persistReducer,
  FLUSH,
  REHYDRATE,
  PAUSE,
  PERSIST,
  PURGE,
  REGISTER,
} from 'redux-persist';
import storage from 'redux-persist/lib/storage';

/**----------reducers----------- */
import { aiPhotoshootingReducer } from './ai-photoshooting/aiPhotoshootingSlice';
import { aiAvatarsReducer } from './ai-avatars/aiAvatarsSlice';
import { bgRemoveReducer } from './bg-remove/bgRemoveSlice';
import { imgUpscalingReducer } from './image-upscaling/imageUpscalingSlice';
import { fashionStoreReducer } from './fashion-store/fashionStoreSlice';
import { userDataReducer } from './user-data/userDataSlice';

/**----------persist configs----------- */
const aiphotoshootingPersistConfig = {
  key: 'aiphotoshooting',
  storage,
  whitelist: ['models'],
};

const aiavatarsPersistConfig = {
  key: 'aiavatars',
  storage,
  whitelist: ['ai_avatars'],
};

const bgremovePersistConfig = {
  key: 'bgremove',
  storage,
  whitelist: [],
};

const imageUpscalingPersistConfig = {
  key: 'imageUpscaling',
  storage,
  whitelist: [],
};

const fashionStorePersistConfig = {
  key: 'fashionStore',
  storage,
  whitelist: [],
  blacklist: ['shopifyApp'],
};

const userDataPersistConfig = {
  key: 'userData',
  storage,
  whitelist: [],
};

/**----------configure store----------- */
export const store = configureStore({
  reducer: {
    aiphotoshooting: persistReducer(
      aiphotoshootingPersistConfig,
      aiPhotoshootingReducer
    ),
    aiavatars: persistReducer(aiavatarsPersistConfig, aiAvatarsReducer),
    bgremove: persistReducer(bgremovePersistConfig, bgRemoveReducer),
    imageupscaling: persistReducer(
      imageUpscalingPersistConfig,
      imgUpscalingReducer
    ),
    fashionstore: persistReducer(
      fashionStorePersistConfig,
      fashionStoreReducer
    ),
    userdata: persistReducer(userDataPersistConfig, userDataReducer),
  },
  middleware: getDefaultMiddleware =>
    getDefaultMiddleware({
      serializableCheck: {
        ignoredActions: [
          FLUSH,
          REHYDRATE,
          PAUSE,
          PERSIST,
          PURGE,
          REGISTER,
          'fashionstore/fsSetOwnFilesForOrder',
          'fashionstore/fsSetShopifyParams',
        ],
        ignoredPaths: ['fashionstore'],
      },
    }),
});

export const persistor = persistStore(store);
